/** Shared number and date formatting, matching what the Android app shows. */

export function distanceKm(meters: number | undefined): string {
  if (meters === undefined) return '—'
  return (meters / 1000).toFixed(2)
}

export function duration(seconds: number | undefined): string {
  if (seconds === undefined || seconds <= 0) return '—'
  const total = Math.round(seconds)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const mm = String(m).padStart(2, '0')
  const ss = String(s).padStart(2, '0')
  return h > 0 ? `${h}:${mm}:${ss}` : `${m}:${ss}`
}

/** Minutes and seconds per kilometre. */
export function pace(secondsPerKm: number | undefined): string {
  if (secondsPerKm === undefined || !Number.isFinite(secondsPerKm) || secondsPerKm <= 0) return '—'
  if (secondsPerKm > 3600) return '—'
  const m = Math.floor(secondsPerKm / 60)
  const s = Math.round(secondsPerKm % 60)
  return s === 60 ? `${m + 1}:00` : `${m}:${String(s).padStart(2, '0')}`
}

export function paceFromDistanceAndTime(meters: number, seconds: number): string {
  if (meters < 20 || seconds <= 0) return '—'
  return pace(seconds / (meters / 1000))
}

export function paceFromSpeed(speedMps: number | undefined): string {
  if (speedMps === undefined || speedMps < 0.28) return '—'
  return pace(1000 / speedMps)
}

const DAY_AND_TIME = new Intl.DateTimeFormat(undefined, {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

const TIME_ONLY = new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' })

export function dayAndTime(iso: string | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? '—' : DAY_AND_TIME.format(date)
}

export function timeOnly(iso: string | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? '—' : TIME_ONLY.format(date)
}

export function fileStamp(iso: string | undefined): string {
  if (!iso) return 'run'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return 'run'
  const pad = (n: number) => String(n).padStart(2, '0')
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`
  )
}

export function integer(value: number | undefined, suffix = ''): string {
  return value === undefined ? '—' : `${Math.round(value)}${suffix}`
}
